var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import MatButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { DeterminateLoadingCircular } from '../Loading';
import { COLOR } from '../theme/colors';
function invColor(variant = 'contained') {
    if (variant === 'contained')
        return COLOR.commonColor.white;
    else
        return COLOR.commonColor.primary;
}
function getLoadingIconSize() {
    return 16;
}
export const Button = (_a) => {
    var { loading } = _a, otherProps = __rest(_a, ["loading"]);
    const disabled = useMemo(() => otherProps.disabled || loading, [loading, otherProps.disabled]);
    const Icon = useMemo(() => {
        const size = getLoadingIconSize();
        if (!otherProps.determinate) {
            return (_jsx(CircularProgress, { size: size, style: { color: invColor(otherProps.variant) } }));
        }
        return (_jsx(DeterminateLoadingCircular, { progress: otherProps.progress, size: size, dark: true }));
    }, [otherProps.size, otherProps.variant, otherProps.progress]);
    const loadingProps = useMemo(() => {
        if (!otherProps.loadingPosition || otherProps.loadingPosition === 'start') {
            return {
                startIcon: Icon,
            };
        }
        return {
            endIcon: Icon,
        };
    }, [otherProps.loadingPosition, Icon]);
    return (_jsx(MatButton, Object.assign({ variant: "contained", color: "primary" }, otherProps, { disabled: disabled }, (loading && loadingProps))));
};
export default Button;
